import { RichText } from "@wordpress/block-editor";
import { getBlockDefaultClassName } from "@wordpress/blocks";

const ContactDeprecatedV1 = {
  save({ attributes }) {
    const { icon, title, contact } = attributes;
    const iconFileName =
      icon === undefined ? `illu-contact.svg` : `contact_${icon}.png`;

    const className = getBlockDefaultClassName('abs/content-contact-block');

    return (
      <div className={className}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-6 contact__img">
              <img
                src={`/modules/custom/abs_blocks/blocks/content-contact/img/${iconFileName}`}
                alt="Kontakt"
              />
            </div>
            <div className="col-sm-6 contact__body">
              {title && <RichText.Content tagName="h2" value={title} />}
              {contact && <RichText.Content tagName="p" value={contact} />}
            </div>
          </div>
        </div>
      </div>
    );
  },
};

export default ContactDeprecatedV1;
